import React, { useEffect } from "react";

import { Container, FormLogin, Overlay } from "./styles";
import Input from "../../../components/Input";
import logoImg from "../../../assets/senai_sidebar.png";
import { Link } from "react-router-dom";
import Header from "../../../components/Header";
import { useState } from "react";
import { mascaraCnpj } from "../../../services/utils";
import { useRef } from "react";
import { api } from "../../../services/api";
import Alerts from "../../../components/Alerts";
import { AnimatedDone } from "../../empresa/EditarVaga/styles";

function RedefinirSenha() {
  const headerLinks = [{ label: "Lembrei", to: "/" }];

  const btnEnviarRef = useRef();

  const [empresa, setEmpresa] = useState({
    cnpj: "",
    finalTelefone: "",
  });

  const [mensagem, setMensagem] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  //habilita / desabilita botão
  useEffect(() => {
    if (btnEnviarRef.current) {
      let buttonDisabled = true;

      if (empresa.cnpj.length === 18 && empresa.finalTelefone.length === 4) {
        buttonDisabled = false;
      }

      btnEnviarRef.current.disabled = buttonDisabled;
    }
  }, [empresa]);

  //manipular o loading
  useEffect(() => {
    if (btnEnviarRef.current) {
      if (loading) {
        btnEnviarRef.current.disabled = true;
        btnEnviarRef.current.innerHTML = "Verificando...";
      } else {
        btnEnviarRef.current.innerHTML = "Enviar";
      }
    }
  }, [loading]);

  const handlerCnpj = (e) => {
    setEmpresa({ ...empresa, cnpj: mascaraCnpj(e.target.value) });
  };

  const handlerInput = (e) => {
    setEmpresa({ ...empresa, [e.target.id]: e.target.value });
  };

  const enviar = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const empresaReset = Object.assign({}, empresa);

      empresaReset.cnpj = empresaReset.cnpj.replace(/[^0-9]+/g, "");

      await api.post("/empresas/reset-senha", empresaReset);

      setDone(true);
      setEmpresa({ cnpj: "", finalTelefone: "" });
      setLoading(false);
    } catch (e) {
      if (e.response) {
        setEmpresa({ ...empresa, finalTelefone: "" });
        setLoading(false);
        document.querySelector("#finalTelefone").focus();
        return setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: e.response.data.erro,
        });
      }
      setEmpresa({ ...empresa, finalTelefone: "" });
      setLoading(false);
      setMensagem({
        show: true,
        titulo: "Erro",
        detalhe: "Erro no servidor, tente novamente mais tarde.",
      });
    }
  };

  return (
    <Container>
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      <Overlay />
      <Header links={headerLinks} />
      <FormLogin onSubmit={enviar}>
        <header>
          <img src={logoImg} alt="Logo do Senai" />
        </header>
        <section>
          {!done ? (
            <>
              <h1>Vamos criar uma nova senha</h1>
              <Input
                type="text"
                placeholder="99.999.9999/0009-99"
                label="CNPJ"
                maxLength={18}
                value={empresa.cnpj}
                handler={handlerCnpj}
                required
              />
              <Input
                id="finalTelefone"
                type="text"
                maxLength="4"
                placeholder="9876"
                label="4 últimos dígitos do telefone"
                value={empresa.finalTelefone}
                handler={handlerInput}
                required
              />
              <button disabled={true} ref={btnEnviarRef}>
                Enviar
              </button>{" "}
            </>
          ) : (
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <h1>Pronto!</h1>
              <AnimatedDone size={100} />
              <h1>Enviamos uma nova senha para o seu e-mail</h1>
              Não esqueça de verifica nos spams
            </div>
          )}

          <Link to="/">Voltar</Link>
        </section>
      </FormLogin>
    </Container>
  );
}

export default RedefinirSenha;
